"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQInfoToJSON = exports.FAQInfoFromJSONTyped = exports.FAQInfoFromJSON = exports.instanceOfFAQInfo = void 0;
var runtime_1 = require("../runtime");
var FAQItem_1 = require("./FAQItem");
/**
 * Check if a given object implements the FAQInfo interface.
 */
function instanceOfFAQInfo(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFAQInfo = instanceOfFAQInfo;
function FAQInfoFromJSON(json) {
    return FAQInfoFromJSONTyped(json, false);
}
exports.FAQInfoFromJSON = FAQInfoFromJSON;
function FAQInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'buttonText': !(0, runtime_1.exists)(json, 'buttonText') ? undefined : json['buttonText'],
        'faqText': !(0, runtime_1.exists)(json, 'faqText') ? undefined : (json['faqText'] === null ? null : json['faqText'].map(FAQItem_1.FAQItemFromJSON)),
    };
}
exports.FAQInfoFromJSONTyped = FAQInfoFromJSONTyped;
function FAQInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'title': value.title,
        'buttonText': value.buttonText,
        'faqText': value.faqText === undefined ? undefined : (value.faqText === null ? null : value.faqText.map(FAQItem_1.FAQItemToJSON)),
    };
}
exports.FAQInfoToJSON = FAQInfoToJSON;
